export class VehicleNameFormatter {
  static removeYearFromModelName(vehicle: any, isAudiMake: boolean): string | undefined {
    if (!vehicle.modelName) return undefined;
    return isAudiMake ? vehicle.modelName.toString().slice(5) : vehicle.modelName;
  }

  static isAudiMake(vehicle?: any): boolean {
    return vehicle?.titleText?.includes('Audi') ?? false;
  }
}
